import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  template: `
    <section class="access-denied">
      <h1>Access denied</h1>
      <p>Your account is authenticated, but it is not a member of the required group.</p>
      <p class="hint">Please contact the application administrator to request access.</p>
    </section>
  `,
  styles: [`
    :host {
      display: block;
      min-height: 100vh;
      padding: 2rem;
      box-sizing: border-box;
      background: linear-gradient(135deg, #f5f7fb 0%, #edf2f8 100%);
    }

    .access-denied {
      max-width: 720px;
      margin: 4rem auto;
      background: #fff;
      border: 1px solid #e7ebf1;
      border-radius: 16px;
      padding: 2rem;
      box-shadow: 0 16px 44px rgba(30, 53, 90, 0.08);
    }

    h1 {
      margin: 0 0 0.75rem;
      color: #12263f;
      font-size: clamp(1.5rem, 1.2rem + 1vw, 2rem);
      line-height: 1.25;
    }

    p {
      margin: 0;
      color: #3a4a62;
      line-height: 1.6;
      font-size: 1rem;
    }

    .hint {
      margin-top: 0.75rem;
      color: #5f6f88;
      font-size: 0.95rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedComponent {}
